import _ from "underscore";
import TimeParser from "./time-parser";
import Interval from "./interval";

var microFactor = 1000000;

var View = Interval.View.extend({
    getViewValue: function () {
        return TimeParser.toMicroseconds(this.value.getValue(), this.unit.getValue()) / microFactor;
    },

    getValueInMicroseconds: function (value) {
        return value * microFactor;
    },
});

export default _.extend({}, Interval, {
    Model: Interval.Model,
    View: View,
});
